module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "rt-lookup-dialog",
    attrs: {
      "size": "tiny",
      "close-on-click-modal": false,
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "搜索"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.searchPlaceholder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSearch
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "lookupTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "450",
      "highlight-current-row": "",
      "data": _vm.tableData,
      "stripe": ""
    },
    on: {
      "row-click": _vm.handleClick,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40",
      "selectable": _vm.selectable
    }
  }), _vm._v(" "), _vm._l((_vm.displayFields), function(display) {
    return _c('el-table-column', {
      key: display.name,
      attrs: {
        "show-overflow-tooltip": true,
        "prop": display.name,
        "label": display.label,
        "width": display.width
      }
    })
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.pageSizes,
      "layout": _vm.layout,
      "total": _vm.totalRecordCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleIndexChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c693b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup-chooser/src/lookup-chooser-dialog.vue
// module id = 686
// module chunks = 220